import CompletionStatsTable from '../../components/metrics/CompletionStatsTable';

const CompletionMetricsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Número de Tasks completados</h1>
      <CompletionStatsTable />
    </div>
  );
};

export default CompletionMetricsPage;
